<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h2>Alt Kampanya Ekle</h2>

      <v-row style="margin-top: 50px;">
        <v-col cols="12" md="4">
          <h4>Kampanya Başlık</h4>
          <v-text-field
            v-model="campaign.title"
            maxlength="255"
            counter="255"
            :rules="titleRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <h4>Mobil Başlık</h4>
          <v-text-field
            v-model="campaign.shortDescription"
            maxlength="255"
            counter="255"
            :rules="shortDescriptionRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <h4>Son Kullanım Tarihi</h4>

          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="campaign.endDate"
                style="font-weight: bold;"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="campaign.endDate"
              :min="new Date().toISOString().substr(0, 10)"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4" sm="3">
          <h4>Kampanya tipi</h4>
          <v-select
            v-model="campaign.type"
            :items="campaignTypeList"
            data-vv-name="select"
            item-text="name"
            item-value="value"
            :rules="campaignTypeRules"
            @change="campaignTypeChange"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="4" sm="3">
          <h4>Segmentasyon Tipi</h4>
          <v-select
            v-model="campaign.segmentType"
            :items="
              ['', ...allSegments].map((segment, i) => {
                const segmentType = allSegmentTypes.find(
                  (x) => x.value == segment,
                )
                return {
                  value: segment,
                  label: segmentType ? segmentType.label : '',
                }
              })
            "
            item-text="label"
            item-value="value"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col v-if="campaign.type !== 'General'" cols="12" md="4">
          <h4>İndirim Tutarı (TL)</h4>
          <v-text-field
            v-model="campaign.discount"
            type="number"
            min="1"
            max="25000"
            :rules="campaign.type === 'General' ? noRule : discountRules"
            required
          ></v-text-field>
        </v-col>
        <v-col v-if="campaign.type !== 'General'" cols="12" md="4" sm="3">
          <h4>
            Geçerlilik Süresi / Aylık tekrar adeti
            <v-icon
              style="font-size: 17px;"
              v-if="!alert"
              color="#4d48f9"
              @click="alert = !alert"
            >
              info
            </v-icon>

            <v-alert
              v-model="alert"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >
              Sadece aylık üyelikler için geçerlidir
            </v-alert>
          </h4>
          <v-select
            v-model="campaign.usageCount"
            :items="usageCountLimitOptions"
            data-vv-name="select"
            item-text="name"
            item-value="value"
            required
          ></v-select>
        </v-col>
      </v-row>
      <v-row
        v-if="campaign.type === 'Partnership' || campaign.type === 'CouponCode'"
      >
        <v-col cols="12" md="4" sm="3">
          <h4>Kod tipi</h4>
          <v-select
            v-model="campaign.codeType"
            :items="codeTypeList"
            data-vv-name="select"
            item-text="name"
            item-value="value"
            required
          ></v-select>
        </v-col>
        <v-col v-if="campaign.codeType !== 1" cols="12" md="4">
          <h4>
            Toplam Kod Adedi
          </h4>
          <v-text-field
            v-model="campaign.userCount"
            name="name"
            value="value"
            type="number"
            @input="handleInput"
            :rules="
              campaign.codeType === 'General'
                ? codeUsageRules
                : campaign.codeType === 'Unique'
                ? codeCountRules
                : noRule
            "
            min="1"
            required
          ></v-text-field>
        </v-col>

        <v-col v-if="campaign.codeType === 'General'" cols="12" md="4">
          <h4>Kampanya Kodu</h4>
          <v-text-field
            v-model="campaign.code"
            @keyup="uppercase"
            :maxlength="campaign.codeType === 'General' && isMassCampaign ? 3 : 8"
            :minlength="campaign.codeType === 'General' && isMassCampaign ? 1 : 6"
            :counter="campaign.codeType === 'General' && isMassCampaign ? 3 : 8"
            required
            :rules="
              campaign.codeType === 'General'
                ? isMassCampaign
                  ? codeRuleMassCampaign
                  : codeRules
                : noRule
            "
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h4>Toplu Kampanya Oluştur</h4>
          <v-checkbox color="#4d48f9" v-model="isMassCampaign" />
          <v-dialog
            v-model="showPopup"
            max-width="800px"
            @click:outside="closePopup"
          >
            <v-card>
              <v-card-title>
                <span class="headline">Firma Bilgileri</span>
              </v-card-title>

              <v-card-text>
                <v-data-table
                  style="margin-top: 30px;"
                  :headers="companyHeaders"
                  :items="companySelectList"
                  :items-per-page="10"
                  :options.sync="companySelectListData"
                  :page.sync="companySelectListData.pageNumber"
                  @update:page="getSelectedListPageNumber"
                  @update:items-per-page="getItemPerPageForSelectedList"
                  :footer-props="{
                    'items-per-page-options': [10, 25, 50, 100],
                  }"
                >
                  <template v-slot:top>
                    <v-text-field
                      v-model="companySelectListData.search"
                      label="Ara"
                      class="mx-4"
                    ></v-text-field>
                  </template>

                  <template v-slot:item.check="{ item }">
                    <v-checkbox
                      color="#4d48f9"
                      @change="toggleSelection(item.id)"
                    ></v-checkbox>
                  </template>
                </v-data-table>
                <div class="text-xs-center pt-2">
                  <v-pagination
                    v-model="companySelectListData.pageNumber"
                    color="#4d48f9"
                    :length="pagination.pagesLength"
                    @input="setPageNumber"
                  ></v-pagination>
                </div>

                <v-card-actions>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-btn
                        depressed
                        color="#4d48f9"
                        style="
                          text-transform: none !important;
                          float: left;
                          color: white;
                        "
                        @click="closePopup()"
                      >
                        EKLE
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card-text>
            </v-card>
          </v-dialog>
          <div v-if="selectedCompanies.length > 0 && isMassCampaign">
            <div
              style="
                color: #4d48f9;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 10px;
              "
            >
              <v-icon large style="color: #4d48f9; margin-right: 10px;">
                mdi-information
              </v-icon>
              <div>
                Bu kampanya için girilen bilgilerle aşağıda gözüken seçilmiş
                firmalara ait toplam mağaza sayısı kadar kampanya
                oluşturulacaktır. Oluşturulan kampanya isimlendirmesi otomatik
                olarak yapılacak olup "Girilen Kampanya Başlık - Mağaza adı"
                şeklinde olacaktır.
              </div>
            </div>
            <div style="display: flex;">
              <h3>Firmalar</h3>
              <v-icon
                @click="showPopup = true"
                style="margin-left: 10px; color: black;"
              >
                mdi-pencil
              </v-icon>
            </div>

            <div style="display: flex;">
              <span>
                {{
                  selectedCompanies
                    .map((companyId) => getCompanyTitle(companyId))
                    .join(', ')
                }}
              </span>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h4>Açıklama</h4>
          <v-textarea
            v-model="campaign.description"
            maxlength="2000"
            rows="1"
            auto-grow
            counter="2000"
            :rules="descriptionRules"
            required
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <h4>
            Link
            <v-icon
              style="font-size: 17px;"
              v-if="!alertLink"
              color="#4d48f9"
              @click="alertLink = true"
            >
              info
            </v-icon>

            <v-alert
              v-model="alertLink"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >
              Dış Link eklerken http, https protokollerinin girilmesi
              gereklidir.
              <br />
              Örneğin: http://frink.com.tr, https://frink.com.tr
            </v-alert>
          </h4>
          <v-text-field
            v-model="campaign.link"
            maxlength="255"
            counter="255"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" sm="3">
          <h4>Link tipi</h4>
          <v-select
            v-model="campaign.campaignLinkType"
            :items="campaignLinkTypes"
            :disabled="campaign.link === ''"
            item-text="name"
            item-value="value"
            label="Link Tipi"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>

        <v-col cols="12" md="4">
          <h4>Link Metni</h4>
          <v-text-field
            v-model="campaign.linkText"
            :disabled="campaign.link === ''"
            maxlength="255"
            counter="255"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <h4>
            Öncelik
            <v-icon
              style="font-size: 17px;"
              v-if="!alertPriority"
              color="#4d48f9"
              @click="alertPriority = !alertPriority"
            >
              info
            </v-icon>

            <v-alert
              v-model="alertPriority"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >
              Kampanyanın uygulamadaki sırasını belirtir.
            </v-alert>
          </h4>
          <v-text-field
            v-model="campaign.priority"
            type="number"
            min="0"
            required
            @input="handleInput"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3">
          <h4>Uygulama İçerisinde Göster</h4>
          <v-checkbox v-model="campaign.shown" color="#4d48f9"></v-checkbox>
        </v-col>
        <v-col cols="12" md="3">
          <h4>Aktif/Pasif</h4>
          <v-checkbox v-model="campaign.active" color="#4d48f9"></v-checkbox>
        </v-col>
        <v-col cols="12" md="3">
          <h4>Paket Adı</h4>
          <v-select
            v-model="campaign.subscriptionType"
            @change="filterBySubscriptionType"
            :items="
              allSubscriptionTypes.map((subscription) => {
                return {
                  label: subscriptionLabels[subscription],
                  value: subscription,
                }
              })
            "
            item-text="label"
            item-value="value"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <h4>
            Görsel
            <v-icon
              style="font-size: 17px;"
              v-if="!infoImage"
              color="#4d48f9"
              @click="infoImage = true"
            >
              info
            </v-icon>
          </h4>

          <v-alert
            v-model="infoImage"
            border="left"
            close-text="Close Alert"
            color="#4d48f9"
            dark
            dismissible
          >
            Görsel boyutu: 1000x500
            <br />
            Format: JPG
            <br />
            Dosya boyutu: Maximum 350 KB
          </v-alert>
          <v-img
            style="cursor: pointer;"
            v-if="imgUrl !== '' && imgUrl !== undefined"
            :src="imgUrl"
            aspect-ratio="1.7"
          ></v-img>
          <v-file-input
            show-size
            accept="image/*"
            v-model="campaign.img"
            @change="previewFiles"
            label="Resim yükle"
          ></v-file-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-btn
            depressed
            color="#4d48f9"
            style="text-transform: none !important; float: left; color: white;"
            @click="campaignAdd()"
          >
            EKLE
          </v-btn>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="errorList in this.errorList" :key="errorList">
                {{ errorList }}
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- <v-row>
          
      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SubCampaign',
  data: () => ({
    isMassCampaign: false,
    showPopup: false,
    companySelectListData: {
      pageNumber: 1,
      pageSize: 10,
      search: '',
    },
    companyHeaders: [
      { text: 'Firma Id', value: 'id', align: ' d-none' },
      { text: 'Firma Başlık', value: 'title' },
      { text: '', value: 'check' },
    ],
    selectedCompanies: [],
    pagination: {
      totalItems: 20,
      pagesLength: 0,
    },
    getSelectedListPageNumber(val) {
      this.companySelectListData.pageNumber = val
    },
    getItemPerPageForSelectedList(val) {
      this.companySelectListData.pageSize = val
      this.companySelectListData.pageNumber = 1
    },
    companyList: [],

    selectAll: false,
    alert: false,
    infoImage: false,
    alertPriority: false,
    alertLink: false,
    valid: true,
    titleRules: [
      (v) => !!v || 'Başlık alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    descriptionRules: [
      (v) => !!v || 'Açıklama alanı zorunludur.',
      (v) => v.length <= 2000 || 'Maksimum 2000 karakter olmalıdır.',
    ],
    shortDescriptionRules: [
      (v) => !!v || 'Kısa açıklama alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    campaignTypeRules: [(v) => !!v || 'Kampanya tipi alanı zorunludur.'],
    segmentationTypeRules: [
      (v) => !!v || 'Segmentasyon tipi alanı zorunludur.',
    ],

    discountRules: [
      (v) =>
        parseFloat(v) >= 1 ||
        'İndirim tutarı en az 1 en fazla 25000 olmalıdır.',
      (v) =>
        parseFloat(v) <= 25000 ||
        'İndirim tutarı en az 1 en fazla 25000 olmalıdır.',
    ],
    codeRules: [
      (v) => !!v || 'Kampanya kodu alanı zorunludur.',
      (v) =>
        /^\w+$/.test(v) ||
        'Genel kod yalnızca ingilizce karakterlerden oluşmalıdır.',
      (v) => v.length >= 6 || 'Genel kod 6-8 karakter olmalıdır.',
      (v) => v.length <= 8 || 'Genel kod 6-8 karakter olmalıdır.',
    ],
    codeRuleMassCampaign: [
      (v) => !!v || 'Kampanya kodu alanı zorunludur.',
      (v) =>
        /^\w+$/.test(v) ||
        'Genel kod yalnızca ingilizce karakterlerden oluşmalıdır.',
      (v) =>
        v.length >= 1 ||
        'Toplu kampanya oluşturulacağında bu alana minumum 1, maksimum 3 karakter girişi yapabilirsin.',
      (v) =>
        v.length <= 3 ||
        'Toplu kampanya oluşturulacağında bu alana minumum 1, maksimum 3 karakter girişi yapabilirsin.',
    ],
    noRule: [],
    codeCountRules: [
      (v) => parseInt(v) >= 1 || 'Kod miktarı ez az 1 olmalıdır.',
    ],
    codeUsageRules: [
      (v) =>
        parseInt(v) >= 1 || "Kullanım sayısı miktarı 1'den küçük olmamalıdır.",
    ],
    imgUrl: '',
    campaignLinkTypes: [
      {
        name: 'İç Link',
        value: 'InternalLink',
      },
      {
        name: 'Dış Link',
        value: 'ExternalLink',
      },
    ],
    campaign: {
      title: '',
      img: null,
      description: '',
      shortDescription: '',
      link: '',
      discount: 0.0,
      linkText: '',
      campaignLinkType: 'InternalLink',
      active: true,
      codeType: 'General',
      type: 'CouponCode',
      segmentType: '',
      usageCount: 1,
      userCount: 1,
      shown: true,
      endDate: new Date().toISOString().substr(0, 10),
      priority: 0,
      code: '',
      groupCampaignId: 0,
      companyList: [],
      subscriptionType: 'General',
    },
    menu: false,
    usageCountLimitOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],

    campaignTypeList: [
      {
        name: 'Kupon Kodu',
        value: 'CouponCode',
      },
      {
        name: 'İş Birliği',
        value: 'Partnership',
      },
    ],
    codeTypeList: [
      {
        name: 'Genel Kod',
        value: 'General',
      },
      {
        name: 'Unique Kod',
        value: 'Unique',
      },
    ],
    errorList: [],
    dialog: false,
  }),
  computed: mapGetters([
    'allSegments',
    'allSegmentTypes',
    'companySelectList',
    'allSubscriptionTypes',
    'subscriptionLabels',
  ]),
  created() {
    this.getSegments()
    this.getCompanySelectList(this.companySelectListData).then((response) => {
      this.pagination.totalItems = response.totalCount
      this.pagination.pagesLength = response.totalPages
    })
    this.getSubscriptionTypes().then()
  },
  methods: {
    ...mapActions([
      'addSubCampaigns',
      'getSegments',
      'getCompanySelectList',
      'getSubscriptionTypes',
    ]),
    uppercase() {
      this.campaign.code = this.campaign.code.toUpperCase()
    },
    campaignTypeChange(data) {
      if (
        data !== 'General' &&
        (!!this.campaign.codeType || this.campaign.codeType === 'NoCode')
      )
        this.campaign.codeType = 'General'
    },
    routeGroupCampaign(id) {
      this.$router.push(`/dashboard/groupCampaign/${id}`)
    },
    handleInput(item) {
      if (item.includes('.')) this.campaign.userCount = item.replace('.', '')
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result.split(',')[1])
        reader.onerror = (error) => reject(error)
      })
    },
    campaignAdd() {
      if (this.$refs.form.validate()) {
        if (this.campaign.link !== '' && this.campaign.linkText === '') {
          alert('Link metni alanı dolu olmalıdır')
          return
        }
        this.snackbar = true
        if (this.isMassCampaign)
          this.campaign.companyList = this.selectedCompanies

        const id = this.$route.params.id
        this.campaign.groupCampaignId = Number(id)

        if (this.campaign.img != null) {
          this.addSubCampaigns(this.campaign)
            .then((response) => {
              if (response.processStatus === 'Success') {
                this.routeGroupCampaign(id)
              } else {
                alert(response.friendlyMessage.message)
              }
            })
            .catch((err) => {
              alert(err)
            })
        } else {
          this.addSubCampaigns(this.campaign)
            .then((response) => {
              if (response.processStatus === 'Success') {
                this.routeGroupCampaign(id)
              } else {
                alert(response.friendlyMessage.message)
              }
            })
            .catch((err) => {
              alert(err)
            })
        }
      } else {
        var errors = []
        var x = document.getElementsByClassName('v-messages__message')
        for (var i = 0; i < x.length; i++) errors.push(x[i].innerHTML)
        this.errorList = errors
        this.dialog = true
      }
    },
    previewFiles() {
      if (this.campaign.img === undefined) {
        this.imgUrl = ''
      } else {
        const file = this.campaign.img
        this.imgUrl = URL.createObjectURL(file)
      }
    },
    getItemPerSearchForSelectedList() {
      this.companySelectListData.pageNumber = 1
      this.getCompanySelectList(this.companySelectListData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },

    toggleSelection(campaignId) {
      if (this.selectedCompanies.includes(campaignId)) {
        this.selectedCompanies = this.selectedCompanies.filter(
          (id) => id !== campaignId,
        )
      } else {
        this.selectedCompanies.push(campaignId)
      }
      console.log(this.selectedCompanies)
    },

    getCompanyTitle(companyId) {
      const company = this.companySelectList.find(
        (company) => company.id == companyId,
      )
      return company ? company.title : ''
    },
    closePopup() {
      this.showPopup = false
      if (this.selectedCompanies.length === 0) {
        this.isMassCampaign = false
      }
    },
    filterBySubscriptionType(value) {
      this.campaign.subscriptionType = value
    },
    setPageNumber(val) {
      if (
        (!this.$route.query.page && val == 1) ||
        this.$route.query.page == val
      )
        return
      this.$router.push({ path: this.$route.fullPath, query: { page: val } })
    },
    getPageNumber(val) {
      this.companySelectListData.pageNumber = val
      this.getCompanySelectList(this.companySelectListData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
  },
  watch: {
    isMassCampaign(newVal) {
      this.showPopup = !!newVal;
      this.campaign.code = ''
    },
    'companySelectListData.search'(val, oldVal) {
      if (val.length < 2 && oldVal.length < 1) return
      this.getItemPerSearchForSelectedList()
    },
    '$route.query.page'(val) {
      const pageNumber = val ? Number(val) : 1
      this.getPageNumber(pageNumber)
    },
  },
}
</script>
